import React from 'react';
import type { Moment } from 'moment-timezone';

export const WithdrawalDateTime = ({ dateTime, className = undefined }: { dateTime: Moment; className?: string }) => (
  <span className={className}>{dateTime.format('YYYY/MM/DD HH:mm')}</span>
);
